import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, UrlSegment } from '@angular/router';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';

@Component({
  selector: 'tax-login-menu',
  templateUrl: 'login-menu.component.html',
  styleUrls: ['login-menu.component.sass'],
})

export class LoginMenuComponent implements OnInit, OnDestroy {
  isPasswordPage = false;

  private destroy$: Subject<void> = new Subject<void>();

  constructor(
    private route: ActivatedRoute,
  ) {
  }

  ngOnInit() {
    this.route.url
      .pipe(takeUntil(this.destroy$))
      .subscribe((urlSegments: UrlSegment[]) => {
        this.isPasswordPage = urlSegments.length === 0 || urlSegments[0].path === 'password-restore';
      });
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.unsubscribe();
  }
}
